export default "__VITE_ASSET__Cyi8kXEl__"